module.exports = __webpack_public_path__ + "packs/media/images/stefanie_lopar-93123014add22eeb8bd6a1d7ca0b8e63.jpg";